import React, { CSSProperties } from 'react';

interface ArrowSmallUpProps {
    stroke?: string;
    fill?: string;
    secondaryFill?: string;
    width?: string;
    height?: string;
    style?: CSSProperties;
    className?: string;
}

const ArrowSmallUp: React.FC<ArrowSmallUpProps> = ({
    stroke = 'currentColor',
    fill = 'none',
    secondaryFill = 'currentColor',
    width = '100%',
    height = '100%',
    style,
    className
}) => {
    return (
        <svg
            height={height}
            width={width}
            viewBox="0 0 1060 1060"
            xmlns="http://www.w3.org/2000/svg"
            style={style}
            className={className}
        >
            <g fill={fill}>
                <defs />
                <path
                    className="cls-1"
                    d="M530 297v466"
                    fill="none"
                    stroke={stroke}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="50px"
                />
                <path
                    className="cls-1"
                    d="M721.19 488.51L530 297.32 338.81 488.51"
                    fill="none"
                    stroke={stroke}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="50px"
                />
            </g>
        </svg>
    );
};

export default ArrowSmallUp;